/* eslint-disable no-unused-vars */
import axios from 'axios';
import MockApi from './MockApi';
import registrationRequestSuccess from '../../fixtures/apiResponses/registrationRequestSuccess.json';
import registrationRequestError from '../../fixtures/apiResponses/registrationRequestError.json';
import apiEndpoints from '../globals/apiEndpoints';

export default class OnlineServiceRegistration {
	static send(payload) {
		return axios.post(apiEndpoints.registrationRequest, payload, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		// return MockApi.get({
		// 	data: registrationRequestSuccess,
		// 	timeout: 1000,
		// }).then((data) => ({ data }));
	}
}
